<template>
	<BaseModal :title="t('title')" v-model="model" noPadding>
		<div class="px-5">
			<div class="text-label-secondary -mt-2 px-3 text-center text-sm">
				{{ t('desc') }}
			</div>
			<BaseCard
				class="mt-5 flex items-center gap-4 py-5 pl-5"
				alt
				:class="{
					'pr-5 *:opacity-30': user.isSubscribed,
					'pr-2': !user.isSubscribed
				}"
				@click="openBot()"
				v-hover="{ active: 'scale-95', impact: 'soft' }"
			>
				<div
					class="inline-flex h-11 w-11 items-center justify-center overflow-hidden rounded-full bg-[#3F3F3F]"
				>
					<img :src="DeliveryLogo" class="h-11 w-11" />
				</div>
				<div>
					<div class="text-label-primary text-sm font-medium">
						{{ t('bot') }}
					</div>
					<div class="text-label-secondary mt-1 text-xs font-medium uppercase">
						@RageGifter
					</div>
				</div>
				<div
					class="text-label-tertiary ml-auto inline-flex items-center gap-0.5 text-xs font-medium uppercase"
					v-if="!user.isSubscribed"
				>
					<div>{{ t('message') }}</div>
					<CaretRightIcon class="h-6 w-6" />
				</div>
				<CircleCheckIcon v-else class="text-label-primary ml-auto h-5 w-5" />
			</BaseCard>
		</div>
		<BottomActionsModal class="mt-5 pt-4">
			<BaseButton size="lg" color="primary" class="w-full" @click="retry()">
				{{ t('retryAll') }}
			</BaseButton>
		</BottomActionsModal>
	</BaseModal>
</template>
<script setup lang="ts">
import BaseModal from './BaseModal.vue'
import BaseButton from '../BaseButton.vue'
import BaseCard from '../BaseCard.vue'
import { useI18n } from 'vue-i18n'
import { useUser } from '@/stores/user'
import CircleCheckIcon from '@/assets/icons/circle-check.svg'
import BottomActionsModal from '../BottomActionsModal.vue'
import CaretRightIcon from '@/assets/icons/caret-right.svg'
import DeliveryLogo from '@/assets/illustrations/delivery.jpg'
import { WebApp } from '@grammyjs/web-app'

const { t } = useI18n({
	messages: {
		en: {
			title: 'Delivery failed',
			desc: 'Send a sticker to the delivery bot. We can`t deliver gifts without any interaction from you within the last 24 hours.',
			message: 'message',
			bot: 'Delivery Bot',
			cantSend: 'failed to send',
			retryAll: 'Retry All'
		},
		ru: {
			title: 'ошибка доставки',
			desc: 'Отправь стикер боту доставки. Мы не можем доставить гифты без какого-либо взаимодействия с тобой за последние 24 часа.',
			message: 'написать',
			bot: 'Бот доставки',
			cantSend: 'ошибка отправки',
			retryAll: 'Переотправить все'
		}
	}
})

const model = defineModel<boolean>()

const emit = defineEmits<{
	(e: 'retry'): void
}>()

const close = () => {
	model.value = false
}

const user = useUser()

const retry = async () => {
	emit('retry')
	close()
}

const botLink = `https://t.me/RageGifter`

const openBot = () => {
	WebApp.openTelegramLink(botLink)
}
</script>
